/**
 * Created by danilaeremin on 11.08.15.
 */

/**
 * @class Layer for physical robot settings.
 * @extends PlayerRobotSettingsLayer
 * @constructor
 * @param {pm.AbstractRobot} robot Robot which settings need to display.
 */
var PhysicalRobotSettingsLayer = PlayerRobotSettingsLayer.extend(/** @lends PhysicalRobotSettingsLayer# */{
	ctor: function(robot)
	{
		this._super(robot);

		switch(pm.settings.getPhysicalConnectorType())
		{
			case pm.PhysicalConnectorType.Lego:
				var type = "Lego";
				break;
			case pm.PhysicalConnectorType.BLE:
				var type = "BLE";
				break;
			case pm.PhysicalConnectorType.Sound:
				var type = "Sound";
				break;
			case pm.PhysicalConnectorType.Magnet:
				var type = "Magnet";
				break;
			case pm.PhysicalConnectorType.None:
				var type = "None";
				break;
		}

		this._label.setString(type + " " + robot.id + ", " + LocalizedString("Pattern") + " " + robot.parentLevel.programData[robot.groupID].currentIndex);
	}
});
